export default "__VITE_ASSET__OCFSUZxl__"